export default {
  default: {
    addButton: 'Add to Organisation',
    title: 'Organisations',
  },
}
